// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, any } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmationResult = objectOf({
  info: string,
  developer: any,
});
